import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { key } from 'styled-theme';

import { T } from 'containers';
import { AppText } from 'domain/appText';

import { Flex, Box, Row, Input, Label } from 'rebass';

export const bgColors = {
  empty: '#fff',
  complete: '#efe',
  started: '#ffe',
  error: '#fdd',
};

const ListItem = styled.li`
  list-style: none;
  margin: 0;
  border-bottom: 1px solid #dae6f2;
  padding: 0 18px;
  position: relative;
  transition: all ${key('duration')};

  &:first-child {
    border-top: 1px solid #dae6f2;
  }
`;

const Marker = styled.span`

`;
const Content = styled.div`
  display: block;
`;

const NumberBox = styled(Box)`
  text-align: center;
`;

const BorderBoxText = styled(Box)`
  border-left: 1px solid #ebf1f7;
  min-height: 100px;
  padding: 15px 20px;
  line-height: 20px;

  h5{
    margin: 0;
    font-size: 14px;
  }

  span.no-trailer, span.vehicle-type{
    line-height: 70px;
  }
`;

const BorderBoxTrailer = styled(Box)`
  border-left: 1px solid #ebf1f7;
  min-height: 95px;
  padding: 0px;
  line-height: 20px;

  pre{
    display: none;
  }

  h5{
    margin: 0;
    font-size: 14px;
  }

  hr{
    width: 100%;
    height: 1px;
    margin: 0;
    padding: 0;
    background-color: #ebf1f7;
    border: 0;
  }

  span.no-trailer, span.vehicle-type{
    line-height: 95px;
    padding: 30px 20px;
  }

  p{
    margin: 0;
    padding: 15px 20px;
    border-bottom: 1px solid #ebf1f7;
  }
`;

const BorderBox = styled(Box)`
  border-left: 1px solid #ebf1f7;
  min-height: 95px;

  input{
    padding: 30px 20px;
    height: 40px;
    line-height: 40px;
    &:-moz-read-only { /* For Firefox */
      cursor: not-allowed;
    }
    &:read-only {
      cursor: not-allowed;
    }
  }
`;

const ExtraBox = styled(props => <Box flex="0 auto" {...props} />)`
  display: inline-block;
  vertical-align: middle;
  width: auto;
  margin: 10px;
`;
const ExtraBoxInput = styled(props => <Box flex="1 0" {...props} />)`
  display: inline-block;
  vertical-align: middle;
  width: 43%;

  input:focus{
    box-shadow: none;
  }

  input{
    padding: 0px 0px;
    height: 40px;
    line-height: 40px;
  }
`;

const ExtraLabel = styled(props => <Label f={0} {...props} />)`
  vertical-align: middle;
  text-align: center;
  background-color: #dae6f2;
  border-radius: 4px;
  padding: 7px 10px;
  cursor: pointer;
  margin: 0 2px;
  font-size: 10px;
  line-height: 16px;
  margin-bottom: 0px !important;
`;

class Vehicle extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    number: PropTypes.number,
    description: PropTypes.string,
    type: PropTypes.string,
    regNo: PropTypes.string,
    trailer: PropTypes.object,
    trailerId: PropTypes.string,
    trailerRegNo: PropTypes.string,
    onRegNoChange: PropTypes.func,
    onTrailerRegNoChange: PropTypes.func,
    widths: PropTypes.object,
    readonly: PropTypes.bool,
  };
  static defaultProps = {
    onRegNoChange: () => {},
    onTrailerRegNoChange: () => {},
    widths: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      regNo: props.regNo || '',
      trailerRegNo: (props.trailer && props.trailer.regNo) || '',
    };
  }

  onChange = (event) => {
    this.setState({ regNo: event.target.value });
  }

  onChangeTrailer = (event) => {
    this.setState({ trailerRegNo: event.target.value });
  }

  onBlur = () => {
    this.props.onRegNoChange(this.state.regNo);
  }

  onBlurTrailer = () => {
    this.props.onTrailerRegNoChange(this.state.trailerRegNo);
  }

  render() {
    const { number, description, trailer, widths, readonly } = this.props;
    return (
      <T
        text={[
          AppText.RegistrationNumberPlaceholder,
          AppText.NoTrailer,
          AppText.TrailerRegistrationNumber,
        ]}
        render={([regNoPlaceholder, noTrailer, trailerRegistrationNumber]) => (
          <ListItem>
            <Row px={0} my={0}>
              <Flex align="center" w={1}>
                <NumberBox mx={0} w={widths.space} align="center">
                  <Marker>{number}</Marker>
                </NumberBox>
                <BorderBoxText mx={0} w={widths.vehicleType} align="center">
                  <Content>
                    <span className="vehicle-type">
                      {description}
                    </span>
                    {/* <h5>{type}</h5> */}
                  </Content>
                </BorderBoxText>
                <BorderBox mx={0} w={widths.registrationNumber} align="center">
                  <Content>
                    <Label mb={0}><Input
                      type="text"
                      value={this.state.regNo}
                      onChange={this.onChange}
                      onBlur={this.onBlur}
                      placeholder={regNoPlaceholder}
                      readOnly={readonly}
                    /></Label>
                  </Content>
                </BorderBox>
                {!trailer ? <BorderBoxTrailer mx={0} w={widths.trailer}><span className="no-trailer">{noTrailer}</span></BorderBoxTrailer> : <BorderBoxTrailer mx={0} w={widths.trailer}><p>{trailer.description}</p><ExtraBox>
                  <ExtraLabel htmlFor={`trailer-regNo-${number}`} >{trailerRegistrationNumber}</ExtraLabel>
                </ExtraBox>
                  <ExtraBoxInput>
                    <Input
                      type="text"
                      id={`trailer-regNo-${number}`}
                      value={this.state.trailerRegNo}
                      onChange={this.onChangeTrailer}
                      onBlur={this.onBlurTrailer}
                      placeholder={regNoPlaceholder}
                      readOnly={readonly}
                    />
                  </ExtraBoxInput>
                </BorderBoxTrailer>}
              </Flex>
            </Row>
          </ListItem>
        )}
      />
    );
  }
}


export default Vehicle;



// WEBPACK FOOTER //
// ./src/components/molecules/Vehicle/index.js